import axiosInstance from '../plugin/axios';

interface PreferenceCompanyParams {
  cityProvince: string;
  district?: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface PreferenceCompanyResponse {
  id: number;
  name: string;
  preferred: boolean;
  address: string;
  detail: string;
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

interface CompanyRegistListResponse {
  id: number;
  cityProvince: string;
  district: string;
  name: string;
}

export const fetchPreferenceCompanyList = async (
  params: PreferenceCompanyParams,
): Promise<PreferenceCompanyResponse[]> => {
  try {
    const {
      cityProvince,
      district,
      offset = 0,
      limit = 1000,
      sortBy = 'name',
      order,
    } = params;

    const response = await axiosInstance.get<PreferenceCompanyResponse[]>(
      '/api/preferencecompany/list',
      {
        params: {
          cityProvince,
          district,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('데이터를 불러오는 데 실패했습니다.');
  }
};

export const fetchPreferenceCompanyRegistReation = async (
  companyId: number,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/preferencecompany/registration/${companyId}`,
    );

    return response.data;
  } catch (error) {
    console.error('선호회사를 등록하는 데 실패했습니다.', error);
    throw new Error('선호회사를 등록하는 데 실패했습니다.');
  }
};

export const fetchPreferenceCompanyCancel = async (
  companyId: number,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.delete<ServerResponse>(
      `/api/preferencecompany/registration/${companyId}`,
    );

    return response.data;
  } catch (error) {
    console.error('선호회사를 취소하는 데 실패했습니다.', error);
    throw new Error('선호회사를 취소하는 데 실패했습니다.');
  }
};

export const fetchPreferenceCompanyRegistList = async (): Promise<
  CompanyRegistListResponse[]
> => {
  try {
    const response = await axiosInstance.get<CompanyRegistListResponse[]>(
      '/api/preferencecompany/preference',
    );

    return response.data;
  } catch (error) {
    throw new Error('데이터를 불러 오는데 실패했습니다.');
  }
};
